<template>
  <UDashboardGroup>
    <DashboardSidebar />
    <ImpersonationBanner />

    <slot />

    <ClientOnly>
      <PwaBanner />
    </ClientOnly>

    <SkewNotification v-slot="{ isCurrentChunksOutdated, dismiss, reload }">
      <Transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="opacity-0 translate-y-2"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 translate-y-2"
      >
        <div
          v-if="isCurrentChunksOutdated"
          class="fixed bottom-4 right-4 z-50"
        >
          <div class="flex items-center gap-3 bg-white dark:bg-gray-900 rounded-full shadow-lg ring-1 ring-gray-200 dark:ring-gray-800 px-4 py-3">
            <span class="text-lg">✨</span>
            <div class="text-sm font-medium">
              Mise à jour disponible
            </div>
            <UButton
              color="primary"
              size="xs"
              label="Rafraîchir"
              @click="reload"
            />
            <UButton
              color="neutral"
              variant="ghost"
              size="xs"
              icon="i-heroicons-x-mark-20-solid"
              @click="dismiss"
            />
          </div>
        </div>
      </Transition>
    </SkewNotification>

    <ClientOnly>
      <DashboardNotificationsSlideover />
    </ClientOnly>
  </UDashboardGroup>
</template>

<script lang="ts" setup>
useHead({
  link: [
    { key: 'manifest', rel: 'manifest', href: '/volontaires.webmanifest' },
    { rel: 'apple-touch-icon', href: '/icons/volontaires-apple-touch.png' },
    ...pwaSplashLinks,
  ],
  meta: [
    { name: 'theme-color', content: '#295cb0' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-title', content: 'AP 2.0' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
  ],
})
</script>

<style>

</style>
